import { render, staticRenderFns } from "./MicroneedlingGuide.vue?vue&type=template&id=dfaed274&scoped=true"
import script from "./MicroneedlingGuide.vue?vue&type=script&lang=js"
export * from "./MicroneedlingGuide.vue?vue&type=script&lang=js"
import style0 from "./MicroneedlingGuide.vue?vue&type=style&index=0&id=dfaed274&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfaed274",
  null
  
)

export default component.exports